export function formatAmount(amount, lang) {
	if ( lang == 'en' ) {
		return "$" + amount;
	}
	return amount + " $"
}

function validatePostalCode(val) {
  const sanitizePC = val.replace(/[^a-zA-Z0-9 ]/g, "");
  const formatPC   = sanitizePC.toUpperCase().split("").map( str => str.replace(/\s/g, '')).join('');
  const regex      = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
  return regex.test(formatPC);
}

function validateEmail(val) {
  var email_pattern = /^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i;
  return email_pattern.test(val);
}




export function validateSupporter(supporter, donorFields, lang, strings) {
  let isValid = true;
  donorFields.forEach( f => {
    if ( !isValid ) {
      return;
    }
    const val = supporter[f.name];
    if ( !!f.required && !val ) {
      isValid = false;
      alert(f.placeholder[lang] + ' ' + strings[lang].is_required);
    }
    if ( f.name === 'postalCode' ) {
      const validPC = validatePostalCode(val);

      if ( !validPC ) {
        isValid = false;
        return alert(strings[lang].invalid_postal_code);
      }
    }
    if ( f.name == 'email' ) {
      const validEmail = validateEmail(val);

       if (!validEmail) {
          isValid = false;
          return alert("Invalid email / Courriel invalide");
       }
    }
  });
  return isValid;
}
